import { widgetRegistry } from '../../infrastructure/registry/WidgetRegistry';
import { UpcomingMeetingsWidget, upcomingMeetingsConfig } from './UpcomingMeetingsWidget';
import { AIDailyBriefingWidget, aiBriefingConfig } from './AIDailyBriefingWidget';
import { PendingApprovalsWidget, pendingApprovalsConfig } from './PendingApprovalsWidget';
import { NotificationsWidget, notificationsConfig } from './NotificationsWidget';
import { CompanyHealthWidget, companyHealthConfig } from './CompanyHealthWidget';

/**
 * Cross-role widgets backed by existing endpoints, safe for every dashboard.
 * Role-restricted widgets (Pending Approvals, Company Health) carry
 * `supportedRoles`, so the layout engine filters them out for unauthorized
 * tiers automatically. Registration is idempotent (registry overwrites by id).
 */
export function registerSharedWidgets() {
  widgetRegistry.register(upcomingMeetingsConfig, UpcomingMeetingsWidget);
  widgetRegistry.register(aiBriefingConfig, AIDailyBriefingWidget);
  widgetRegistry.register(pendingApprovalsConfig, PendingApprovalsWidget);
  widgetRegistry.register(notificationsConfig, NotificationsWidget);
  widgetRegistry.register(companyHealthConfig, CompanyHealthWidget);
}
